import styled from 'styled-components';

export const StyledDifferentials = styled.section`
  background-color: var(--dark-bg);
  padding: 100px 0;
  position: relative;
  overflow: hidden;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    color: var(--text-color);
    font-family: Gunar Thin, sans-serif;
    font-weight:border-left;
    letter-spacing: 1.5px;

    .highlight {
      color: var(--primary-color);
    }
  }
`;

export const DifferentialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DifferentialCard = styled.div`
  text-align: center;
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;
  background-color: var(--card-bg);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, var(--primary-color), transparent);
  }

  .icon {
    width: 80px;
    height: 80px;
    background-color: rgba(255, 107, 0, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    font-size: 2rem;
    color: var(--primary-color);
  }

  h3 {
    color: var(--text-color);
    margin-bottom: 15px;
  }

  p {
    color: var(--text-secondary);
    margin-bottom: 0;
  }
`;

export const TechCircuit = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><path d="M0,50 L30,50 L30,30 L70,30 L70,70 L30,70 L30,50" stroke="rgba(255,107,0,0.2)" fill="none" stroke-width="1"/></svg>');
  background-size: 100px 100px;
  background-repeat: repeat;
  opacity: 0.2;
  z-index: 1;
`;
